/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import {
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import './log-ip-field.component.less';

export type TIpVersion = 'ipv4' | 'ipv6';

/**
 * @description
 *     Component used for showing commmunicating info between IPs from a log in its list expanded
 *     content. This component handles partial selection filter for IPs and determines behaviors
 *     upon clicking.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-ip-field',
    templateUrl: 'log-ip-field.component.html',
})
export class LogIpFieldComponent {
    /**
     * Property name of the field.
     */
    @Input()
    public property: string;

    /**
     * An IP is supposed to be a string, regardless ipv4 or ipv6. But in protobuf, ipv4 is asserted
     * as number type, thereby in generated-types. Hence here the type "number" is added for
     * consistency.
     */
    @Input()
    public ip: string | number;

    /**
     * Version of the IP address deciding the layout variations, with the default as IP version 4.
     */
    @Input()
    public version: TIpVersion = 'ipv4';

    /**
     * Property name of the port field.
     */
    @Input()
    public portProperty?: string;

    @Input()
    public port?: number;

    /**
     * If true, both the IP and port search icons will not be shown.
     */
    @Input()
    public noSearchIcons = false;

    @Input()
    public noIpSearchIcon = false;

    @Input()
    public noPortSearchIcon = false;

    /**
     * Usually populated when the component is used by the log cinematic view for its closing.
     */
    @Output()
    public onFilterAdd: EventEmitter<void> = new EventEmitter<void>();
}
